module.exports = __webpack_public_path__ + "img/0Q3A3733_L_Foamcore.1b296f15.jpg";